import { TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

// The row's ⋮. `data-open` lets the row keep it visible while the menu is
// open, without the row knowing anything about the menu library
export const Trigger = forwardRef<HTMLButtonElement>((_, ref) => {
  const { active, toggle } = TinyDropdownMenu.useTrigger()

  return (
    <button
      ref={ref}
      className={clsJoin(css.trigger, active && css.active)}
      onClick={toggle}
      data-open={active}
      aria-label="Comment actions"
    >
      <EllipsisVertical height="16px" width="16px" />
    </button>
  )
})
